export default __webpack_public_path__ + "static/media/american.b27ac31e.png";